import { ChangeEvent, KeyboardEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Input } from '@mui/material';
import { Search as SearchIcon } from '../../../icons/search';
import STRING_KEYS from '../../../language/keys';
import style from './style';

type TableSearchType = {
  handleSearch: (value: string) => void
}

const TableSearch = ({ handleSearch }: TableSearchType): JSX.Element => {
  const [queryValue, setQueryValue] = useState<string>('');
  const { t: translate } = useTranslation();

  const handleQueryChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setQueryValue(event.target.value);
  };

  const handleQueryKeyup = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.code === 'Enter' && queryValue) {
      handleSearch(queryValue);
      setQueryValue('');
    }
  };

  return (
    <Box sx={ style.main.sx }>
      <SearchIcon fontSize={ style.icon.fontSize } />
      <Box sx={ style.box.sx }>
        <Input
          disableUnderline
          fullWidth
          onChange={ handleQueryChange }
          onKeyUp={ handleQueryKeyup }
          placeholder={ translate(STRING_KEYS.SEARCH_INPUT_PLACEHOLDER) }
          value={ queryValue }
        />
      </Box>
    </Box>
  );
};

export default TableSearch;
